import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18n-lite'

import { useAppDispatch, useAppSelector } from 'state/store'
import { interactionModelOperations } from '../redux'
import useWorkflow from './useWorkflow'
import { ActivityValues } from 'types/shared'

type UseValuesFromProcessParams = {
  enabled?: boolean
}

const useValuesFromProcess = ({
  enabled = true
}: UseValuesFromProcessParams) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  const processValuesVariable = searchParams.get('processValuesVariable')

  const [hasAppliedValues, setHasAppliedValues] = useState(
    !processValuesVariable
  )

  const { workflowUuid, flatData } = useAppSelector(
    (state) => state.interactionModel
  )
  const { workflow: process, isFetching } = useWorkflow({ workflowUuid, t })

  const isModelLoaded = !!flatData?.uuid

  useEffect(() => {
    if (
      !enabled ||
      hasAppliedValues ||
      !processValuesVariable ||
      isFetching ||
      !isModelLoaded
    )
      return

    const executionStateString = process?.execution_state

    if (!executionStateString) {
      setHasAppliedValues(true)
      return
    }

    const executionState = process.execution_state

    const rawValues = executionState?.data_container?.[processValuesVariable]

    if (!rawValues) {
      setHasAppliedValues(true)
      return
    }

    const parsedValues = JSON.parse(rawValues) as ActivityValues

    dispatch(interactionModelOperations.setValuesFromProcess(parsedValues))

    setHasAppliedValues(true)
  }, [
    dispatch,
    enabled,
    hasAppliedValues,
    process,
    processValuesVariable,
    isFetching,
    isModelLoaded
  ])

  return {
    hasAppliedValuesFromProcess: hasAppliedValues
  }
}

export default useValuesFromProcess
